class AnchorLink {
  constructor(element) {
    this.element = element

    this.element.addEventListener('click', evt => {
      //evt.preventDefault()

      const hrefValue = evt.currentTarget.getAttribute('href')
      const tagetId = hrefValue.split('#').pop() ?? null
      const targetElement = document.getElementById( tagetId )
      //if the target element is not on the page, try to find the target element by xpath text query
      if (targetElement === null) {
        const targetText = evt.currentTarget.innerText
        const xpath = `//*[text()='${targetText}' and not(@data-anchor-link)]`
        const matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        //add the id to the matching element
        //the scroll to will be performed by the browser
        if (matchingElement) {
          matchingElement.id = tagetId
        }
      }

    })
  }
}

export default AnchorLink
